import React from 'react';

/**
 * Habla wordmark — modern, innovation-forward academy logotype.
 *
 * Design: Space Grotesk bold with negative tracking, paired with a single
 * red accent dot ("Habla.") that gives the word a confident, editorial stop.
 * The dot is the signature detail — recognisable at any size.
 *
 * Props:
 *   size   — 'sm' | 'md' | 'lg' | 'xl' — controls typography scale
 *   tone   — 'dark' | 'light' — adapts to background
 *   className — extra classes (alignment, spacing)
 */
const SIZE_CLASSES = {
  sm: 'text-xl',
  md: 'text-2xl',
  lg: 'text-3xl sm:text-4xl',
  xl: 'text-5xl sm:text-6xl lg:text-7xl',
};

const DOT_SIZE = {
  sm: 'w-1.5 h-1.5 ml-0.5',
  md: 'w-2 h-2 ml-0.5',
  lg: 'w-2.5 h-2.5 ml-1',
  xl: 'w-4 h-4 ml-1.5',
};

export default function Wordmark({ size = 'md', tone = 'dark', className = '', showDot = true }) {
  const textColor = tone === 'light' ? 'text-white' : 'text-[#292524]';
  return (
    <span
      className={`inline-flex items-end ${SIZE_CLASSES[size]} ${textColor} ${className}`}
      style={{
        fontFamily: '"Space Grotesk", "Outfit", sans-serif',
        fontWeight: 700,
        letterSpacing: '-0.035em',
        lineHeight: 0.95,
      }}
      data-testid="habla-wordmark"
    >
      <span>Habla</span>
      {showDot && (
        <span
          aria-hidden="true"
          className={`${DOT_SIZE[size]} rounded-full bg-[#AB1C24] self-end mb-[0.18em]`}
          style={{ boxShadow: '0 0 0 2px rgba(171,28,36,0.12)' }}
        />
      )}
    </span>
  );
}
